export class ObsoleteError extends Error {}